import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProjectInfoDocWidget from '../../../widgets/projectMonitorRecord/ProjectInfoDocWidget'
import { getSubprojectInfoDoc } from '../../../redux/actions/subprojectInfoDoc'

export default function ProjectInfoDoc() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  const [projectCode, setProjectCode] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // console.log('load ProjectName projectId', projectId)

    projectId && handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubprojectInfoDoc(projectId)
      console.log(_schema)
      setSchema(_schema?.model?.forms?.form)
      //setSchema(mockSchema)
      //console.log('mockSchema', mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isSubProjectDep6>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProjectDep6>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  console.log('schema', schema)

  return (
    <>
      {schema && (
        <SidebarProposal isSubProjectDep6>
          <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />

          <ProjectInfoDocWidget schema={schema.form} />
        </SidebarProposal>
      )}
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: null,
  didError: false,
  errorMessage: null,
  model: {
    form: {
      header: null,
      projectInfo: {
        projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
        mainProject: {
          header: 'โครงการหลัก',
          projectId: '783B6B79-B0AA-4738-9033-7A8CA6F28F8D',
          versionCode: '19.0',
          projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
          projectNameTitle: 'ชื่อโครงการ',
          projectName: 'ใช้เป็นตัวอย่างการชุดโครงการสร้างเสริมสุขภาพขนาดเล็ก ',
          projectCodeTitle: 'รหัสโครงการ (เลขที่ข้อตกลง)',
          projectCode: '66-00006 (66-P1-00001)',
          projectTypeTitle: 'ประเภทโครงการ',
          projectType: 'โครงการพัฒนาและปฏิบัติการ',
          projectProposalTypeTitle: 'ประเภทข้อเสนอโครงการ',
          projectProposalType: 'โครงการ',
          statusTitle: 'สถานะ',
          status: 'ดำเนินการ',
          projectProposalStyleTitle: 'ลักษณะข้อเสนอโครงการ',
          projectProposalStyle: 'โครงการใหม่()',
          ownerNameTitle: 'ผู้รับทุน',
          ownerName: 'องค์การบริหารส่วนตำบลบ้านดู่ (นาย สมศักดิ์ มีฐานะ)',
          activityTypeTitle: 'ลักษณะกิจกรรม',
          activityTypeTitle2: '(ประเภทโครงการ)',
          activityType: 'โครงการพัฒนาและปฏิบัติการ',
          responsinatorName: 'นาย สมศักดิ์ มีฐานะ',
          responsinatorNameTitle: 'ผู้รับผิดชอบโครงการ',
          projectStartEndDate: 'dd/mm/yyyy - dd/mm/yyyy',
          projectStartEndDateTitle: 'ระยะเวลาดำเนินการ',
        },
        subProject: {
          header: 'โครงการย่อย',
          projectId: 'B5F698E7-A4F6-43F6-BACD-3E1BC63DCBC6',
          versionCode: '4.0',
          projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
          projectNameTitle: 'ชื่อโครงการ',
          projectName: 'การผลิตและบริโภคผักปลอดสารเคมีในครัวเรือน',
          projectCodeTitle: 'รหัสโครงการ (เลขที่ข้อตกลง)',
          projectCode: '66-00006-01 (66-9912341)',
          projectTypeTitle: 'ประเภทโครงการ',
          projectType: 'โครงการพัฒนาและปฏิบัติการ',
          projectProposalTypeTitle: 'ประเภทข้อเสนอโครงการ',
          projectProposalType: null,
          statusTitle: 'สถานะ',
          status: 'ดำเนินการ',
          projectProposalStyleTitle: 'ลักษณะข้อเสนอโครงการ',
          projectProposalStyle: null,
          ownerNameTitle: 'ผู้รับทุน',
          ownerName: 'นาย วัลลภ บุญประเสริฐ',
          activityTypeTitle: 'ลักษณะกิจกรรม',
          activityTypeTitle2: '(ประเภทโครงการ)',
          activityType: 'โครงการพัฒนาและปฏิบัติการ',
          responsinatorName: 'นาย สมศักดิ์ มีฐานะ',
          responsinatorNameTitle: 'ผู้รับผิดชอบโครงการ',
          projectStartEndDate: 'dd/mm/yyyy - dd/mm/yyyy',
          projectStartEndDateTitle: 'ระยะเวลาดำเนินการ',
        },
      },
      data: [
        {
          documentHeader: 'แบบขออนุมัติโครงการ',
          numberOfsequence: 1,
          totalSize: 1,
          values: [
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'แบบขออนุมัติโครงการ',
              totalSize: 1,
            },
          ],
        },
        {
          documentHeader: 'ข้อตกลง/สัญญารับทุน',
          numberOfsequence: 2,
          totalSize: 2,
          values: [
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'ร่างข้อตกงลงโครงการ',
              totalSize: 2,
            },
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'ข้อตกงลงโครงการ',
              totalSize: 2,
            },
          ],
        },
        {
          documentHeader: 'รายงานความก้าวหน้าโครงการ',
          numberOfsequence: 3,
          totalSize: 3,
          values: [
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'รายงานความก้าวหน้าครั้งที่ 1',
              totalSize: 3,
            },
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'รายงานความก้าวหน้าครั้งที่ 2',
              totalSize: 3,
            },
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'รายงานความก้าวหน้าครั้งที่ 3',
              totalSize: 3,
            },
          ],
        },
        {
          documentHeader: 'ใบเบิกเงินงวด',
          numberOfsequence: 4,
          totalSize: 3,
          values: [
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'ใบเบิกเงินงวดที่ 1',
              totalSize: 3,
            },
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'ใบเบิกเงินงวดที่ 2',
              totalSize: 3,
            },
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'ใบเบิกเงินงวดที่ 3',
              totalSize: 3,
            },
          ],
        },
        {
          documentHeader: 'ขออนุมัติเปลี่ยนแปลงโครงการ',
          numberOfsequence: 5,
          totalSize: 1,
          values: [
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'ขออนุมัติเปลี่ยนแปลงโครงการ',
              totalSize: 1,
            },
          ],
        },
        {
          documentHeader: 'ขออนุมัติปิดโครงการ',
          numberOfsequence: 6,
          totalSize: 1,
          values: [
            {
              id: '575F28A8-5004-4306-BB03-17D4A76CBE38',
              documentName: 'ขออนุมัติปิดโครงการ',
              totalSize: 1,
            },
          ],
        },
      ],
    },
    header: 'เอกสารข้อมูลโครงการ',
    subHeader: null,
    disabled: true,
    isApprover: false,
  },
}
